import React, { Component } from 'react';
import { Image, ListGroup } from 'react-bootstrap';

import CheckedRadio from 'assets/images/checked_radio.svg';
import OutOfStockRadio from 'assets/images/out_of_stock_radio.svg';
import UncheckedRadio from 'assets/images/unchecked_radio.svg';

const PickUpSectionRow = ({ onClick, isSelected, name, description }) => {
  return (
    <ListGroup.Item onClick={onClick} className={'store-list-item'}>
      <div>
        <Image
          src={isSelected ? CheckedRadio : UncheckedRadio}
          className={`store-list-item-button available-icon-filter`}
        />
      </div>
      <div>
        <div className="store_name body-2">{name}</div>
        <div className="store_location body-1">{description}</div>
      </div>
    </ListGroup.Item>
  );
};

export default PickUpSectionRow;
